import {
  StockCountItemStatus,
  StockCountStatus,
} from "@towersystems/roam-common/lib/generated-types";
import { CompletionStatus } from "./types";

export function statusToCompletionStatus(
  status: StockCountStatus
): CompletionStatus {
  switch (status) {
    case StockCountStatus.COUNTING:
      return CompletionStatus.PENDING;
    case StockCountStatus.COMPLETE:
      return CompletionStatus.COMPLETED;
    default:
      console.log("statusToCompletionStatus", status);
      return CompletionStatus.PENDING;
  }
}

export function itemStatusToCompletionStatus(
  status: StockCountItemStatus
): CompletionStatus {
  switch (status) {
    case StockCountItemStatus.PENDING:
      return CompletionStatus.PENDING;
    case StockCountItemStatus.EXPORTED:
      return CompletionStatus.COMPLETED;

    default:
      console.log("statusToCompletionStatus", status);
      return CompletionStatus.PENDING;
  }
}
